import c from 'classnames';
import React from 'react';

import { TextColor, Typography } from '@repo/ui';
import { SLIDE_BACKGROUND_COLORS } from '../slideBackgroundColors';

import ellipse1 from 'assets/images/summary/first-look/ellipse_1.svg';
import ellipse2 from 'assets/images/summary/first-look/ellipse_2.svg';
import microbes from 'assets/images/summary/first-look/microbes.svg';

import slideStyles from './Slides.module.css';
import styles from './TopThreeIntro.module.css';

interface TopThreeIntroProps {
  count: number;
}

export const TopThreeIntro: React.FC<TopThreeIntroProps> = ({ count }) => {
  return (
    <div
      className={c(slideStyles.slideWrapper, styles.slideContainer)}
      style={{ backgroundColor: SLIDE_BACKGROUND_COLORS.topThreeIntro }}
    >
      <div className={styles.contentContainer}>
        <img src={ellipse1} alt='ellipse' className={styles.ellipse1} />
        <img src={ellipse2} alt='ellipse' className={styles.ellipse2} />
        <img src={microbes} alt='microbes' className={styles.microbes} />
        <div className={styles.centerText}>
          {count > 1 ? (
            <Typography variant='heading-xl'>
              Overall, the{'\n'}
              <Typography variant='heading-xl' color={TextColor.GREEN}>
                top {count} metrics
              </Typography>
              {'\n'}we recommend{'\n'}attending to...
            </Typography>
          ) : (
            <Typography variant='heading-xl'>
              Your top priority{'\n'}we recommend{'\n'}attending to...
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
};
